import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["showList"],
  _excluded2 = ["sellTicket"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import VMask from '@/components/common/VMask.vue';
import { formatWeekDayStr, formatDate } from '@/utils/formatDate';
import Drip from 'drip';
export default {
  // 场次列表选择
  name: 'show-list-modal',
  components: {
    'v-mask': VMask
  },
  props: {
    // 项目id
    projectId: {
      type: Number,
      required: true
    },
    earlyOnSaleDay: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      dateList: [],
      selectedDate: '',
      // 选中的日期
      curSchedule: null,
      // 排期map 日期：场次列表
      schedule: {},
      selectedDayShowList: [],
      selectedShow: null,
      projectInfo: null,
      isShowListLoading: true
    };
  },
  computed: {
    activeDateIndex: function activeDateIndex() {
      return this.dateList.map(function (a) {
        return a.dateStr;
      }).indexOf(this.selectedDate);
    }
  },
  watch: {
    projectId: 'getDayList'
  },
  created: function created() {
    this.getDayList();
  },
  methods: {
    // 获取场次日历列表
    getDayList: function getDayList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$axios$get, code, data, msg, items, firstShowTime, nowDate, defaultSelectedDateStr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.projectId) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return axios.get("/v2/performance/".concat(_this.projectId, "/calendar"), {
                params: {
                  date: formatDate(new Date(), 'yyyy-MM-dd'),
                  showDay: _this.earlyOnSaleDay + 1,
                  dateType: 1
                }
              });
            case 4:
              _yield$axios$get = _context.sent;
              code = _yield$axios$get.code;
              data = _yield$axios$get.data;
              msg = _yield$axios$get.msg;
              if (!(code !== 200)) {
                _context.next = 11;
                break;
              }
              _this.$toast(msg);
              return _context.abrupt("return");
            case 11:
              items = data.items, firstShowTime = data.firstShowTime;
              nowDate = new Date();
              nowDate.setHours(0);
              nowDate.setMinutes(0);
              nowDate.setSeconds(0);
              nowDate.setMilliseconds(0);
              _this.dateList = new Array(_this.earlyOnSaleDay + 1).fill(0).map(function (a, index) {
                var nextDay = new Date(nowDate.getTime());
                nextDay.setDate(nextDay.getDate() + index);
                if (nextDay.getTime() < firstShowTime) {
                  return null;
                }
                var dateObj = {
                  hasDiscount: false,
                  hasShowList: false
                };
                dateObj.weekDayStr = formatWeekDayStr(nextDay);
                dateObj.dayStr = formatDate(nextDay, 'MM-dd');
                dateObj.dateStr = formatDate(nextDay, 'yyyy-MM-dd');
                return dateObj;
              }).filter(function (a) {
                return !!a;
              });
              items.forEach(function (date) {
                var showDateStr = formatDate(new Date(date.currentTime), 'yyyy-MM-dd');
                var hasShowDate = _this.dateList.find(function (a) {
                  return a.dateStr === showDateStr;
                });
                if (!hasShowDate) return;
                hasShowDate.hasDiscount = date.hasDiscount;
                hasShowDate.hasShowList = true;
              });
              // 设置默认选中的日期
              if (firstShowTime) {
                defaultSelectedDateStr = formatDate(new Date(firstShowTime), 'yyyy-MM-dd');
                _this.pickDate({
                  dateStr: defaultSelectedDateStr,
                  hasShowList: true
                });
              }
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取指定日期下的场次列表
    getDayShowList: function getDayShowList(dateStr) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$axios$get2, code, data, msg, showList, projectInfo, dayDate;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!_this2.projectId || !dateStr)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this2.isShowListLoading = true;
              _this2.selectedDayShowList = _this2.schedule[dateStr] || [];
              _context2.next = 6;
              return axios.get("ju/performance/".concat(_this2.projectId, "/calendar/shows"), {
                params: {
                  date: dateStr
                }
              });
            case 6:
              _yield$axios$get2 = _context2.sent;
              code = _yield$axios$get2.code;
              data = _yield$axios$get2.data;
              msg = _yield$axios$get2.msg;
              _this2.isShowListLoading = false;
              if (!(code !== 200)) {
                _context2.next = 14;
                break;
              }
              _this2.$toast(msg || '喵～出错了');
              return _context2.abrupt("return");
            case 14:
              if (data) {
                _context2.next = 16;
                break;
              }
              return _context2.abrupt("return");
            case 16:
              showList = data.showList, projectInfo = _objectWithoutProperties(data, _excluded);
              if (showList) {
                _context2.next = 19;
                break;
              }
              return _context2.abrupt("return");
            case 19:
              // 是否是拼场售卖模式
              projectInfo.isShowPoolMode = projectInfo.saleType === 1;
              _this2.projectInfo = projectInfo;
              dayDate = new Date(dateStr); // 次日
              dayDate.setDate(dayDate.getDate() + 1);
              _this2.selectedDayShowList = _this2.schedule[dateStr] = showList.map(function (show) {
                var jointCurrentNum = show.jointCurrentNum,
                  toJointNum = show.toJointNum,
                  playerMinNumLimit = show.playerMinNumLimit,
                  playerMaxNumLimit = show.playerMaxNumLimit,
                  ticketList = show.ticketList;
                show.sellTicket = ticketList[0];
                show.sellTicket.sellPrice = +show.sellTicket.sellPrice;
                show.sellTicket.ticketPrice = +show.sellTicket.ticketPrice;
                var showStartDate = new Date(show.startTime);
                var showEndDate = new Date(show.endTime);
                var showStartTimePrefix = '';
                var showEndTimePrefix = '';
                if (dayDate.getDate() === showStartDate.getDate()) {
                  // 开始时间是次日
                  showStartTimePrefix = '次日';
                } else if (dayDate.getDate() === showEndDate.getDate()) {
                  // 结束时间是次日
                  showEndTimePrefix = '次日';
                }
                show.displayShowTime = "".concat(showStartTimePrefix).concat(formatDate(showStartDate, 'hh:mm'), "-").concat(showEndTimePrefix).concat(formatDate(showEndDate, 'hh:mm'));
                show.displayFullShowTime = "".concat(formatDate(showStartDate, 'yyyy-MM-dd'), " ").concat(formatWeekDayStr(showStartDate), " ").concat(formatDate(showStartDate, 'hh:mm'), "-").concat(showEndTimePrefix).concat(formatDate(showEndDate, 'hh:mm'));
                show.offSaleTimeStr = formatDate(new Date(show.offSaleTime), 'yyyy-MM-dd hh:mm');

                // 票档购买限制
                show.maxBuyLimit = Math.min(show.maxBuyLimitPerOrder, show.maxBuyLimitPerUser);
                show.maxBuyLimitPerOrder = Math.min(show.maxBuyLimitPerOrder, projectInfo.maxBuyLimitPerOrder);

                // 已售完
                show.disabled = jointCurrentNum >= playerMaxNumLimit;

                // 单独售卖模式时，当可售库存＜每单场次限购时出现
                if (projectInfo.saleType === 2 && show.sellTicket.remainingStock < show.maxBuyLimitPerOrder) {
                  show.remainingStockStr = "\u4EC5\u5269 ".concat(show.sellTicket.remainingStock, " \u4EFD");
                }

                // 根据拼场状态人数生成描述文字
                var joinStatusDesc = '';
                if (jointCurrentNum > 0 && jointCurrentNum < playerMinNumLimit) {
                  joinStatusDesc = "\u5DF2\u52A0\u5165".concat(jointCurrentNum, "\u4EBA\uFF0C\u5DEE<span style=\"color: #FF4444\">").concat(playerMinNumLimit - jointCurrentNum, "</span>\u4EBA\u53EF\u5F00\u573A");
                } else if (playerMinNumLimit <= jointCurrentNum && jointCurrentNum < playerMaxNumLimit) {
                  joinStatusDesc = "\u5DF2\u52A0\u5165".concat(jointCurrentNum, "\u4EBA\uFF0C\u8BE5\u573A\u6B21\u5DF2\u62FC\u6210\uFF0C\u8FD8\u53EF\u52A0\u5165<span style=\"color: #FF4444\">").concat(toJointNum, "</span>\u4EBA");
                } else if (jointCurrentNum >= playerMaxNumLimit) {
                  joinStatusDesc = "\u8BE5\u573A\u6B21\u5DF2\u8BA2\u6EE1";
                }

                // 非拼场售卖模式则不展示，拼场信息
                if (projectInfo.saleType !== 1) {
                  joinStatusDesc = '';
                }

                //场次是否停止售卖
                var isStopSell = Date.now() > show.offSaleTime;
                if (isStopSell) {
                  show.disabled = true;
                  joinStatusDesc = '该场次已停止售卖';
                }
                show.joinStatusDesc = joinStatusDesc;
                var customData = {
                  show_id: show.showId,
                  cityId: Drip.constant.cityId || 0
                };
                window.seedAction({
                  bid: 'b_movie_slekkipb_mv',
                  evt: 'view',
                  custom: Object.assign({}, customData, {
                    custom: Object.assign({}, customData)
                  })
                });
                return show;
              });
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 选中日期
    pickDate: function pickDate(date) {
      if (date.dateStr !== this.selectedDate) {
        this.selectedDate = date.dateStr;
        this.getDayShowList(this.selectedDate);
        this.selectedShow = null;
      }
    },
    // 选中场次
    pickSession: function pickSession(show) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (show) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              if (!show.disabled) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              if (!(!_this3.selectedDayShowList || !_this3.selectedDayShowList.length)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              _this3.selectedShow = _this3.selectedDayShowList.find(function (a) {
                return a.showId === show.showId;
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 获取票档的库存信息
    getTicketStockInfo: function getTicketStockInfo(showId, ticketId) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _yield$axios$get3, code, data, msg;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return axios.get("performance/show/".concat(showId, "/ticket/").concat(ticketId, "/salesplans"));
            case 2:
              _yield$axios$get3 = _context4.sent;
              code = _yield$axios$get3.code;
              data = _yield$axios$get3.data;
              msg = _yield$axios$get3.msg;
              if (!(code !== 200)) {
                _context4.next = 9;
                break;
              }
              _this4.$toast(msg || '喵～出错了');
              return _context4.abrupt("return", null);
            case 9:
              return _context4.abrupt("return", (data || []).find(function (a) {
                return a.ticketClassId == ticketId;
              }));
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 跳转确认订单页
    goBuyPages: function goBuyPages() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var ticketInfo, _this5$selectedShow, sellTicket, showInfo, projectId, projectInfo, buyInfoObj, customData;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (_this5.selectedShow) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _this5.getDayShowList(_this5.selectedDate);
              _context5.next = 5;
              return _this5.getTicketStockInfo(_this5.selectedShow.showId, _this5.selectedShow.sellTicket.ticketId);
            case 5:
              ticketInfo = _context5.sent;
              if (ticketInfo) {
                _context5.next = 8;
                break;
              }
              return _context5.abrupt("return");
            case 8:
              if (ticketInfo.hasInventory) {
                _context5.next = 12;
                break;
              }
              _this5.selectedShow = null;
              _this5.$toast('该场次已订满啦，请看看其他场次吧~');
              return _context5.abrupt("return");
            case 12:
              _this5$selectedShow = _this5.selectedShow, sellTicket = _this5$selectedShow.sellTicket, showInfo = _objectWithoutProperties(_this5$selectedShow, _excluded2);
              projectId = _this5.projectInfo.projectId;
              projectInfo = {
                performanceId: projectId
              };
              sellTicket.remainingStock = ticketInfo.currentAmount;
              buyInfoObj = {
                projectInfo: projectInfo,
                showInfo: showInfo,
                ticketInfo: sellTicket,
                buyAmount: 1,
                ticketTotalPrice: sellTicket.sellPrice
              };
              _context5.next = 19;
              return Drip.setStore('buyInfo', buyInfoObj);
            case 19:
              _this5.go('/buy');
              customData = {
                show_id: showInfo.showId,
                cityId: Drip.constant.cityId || 0
              };
              window.seedAction({
                bid: 'b_movie_m8n25nyp_mc',
                custom: Object.assign({}, customData, {
                  custom: Object.assign({}, customData)
                })
              });
            case 22:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    closeModal: function closeModal() {
      this.$emit('closeModal');
    }
  }
};